import React, { useEffect } from 'react';
import styled from 'styled-components';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { ImageLazyLoad } from '../ImageLazyLoad';

const IMAGE_WIDTH = 33;

const SliderImage = styled(ImageLazyLoad)`
  border-radius: 20px;
  width: ${IMAGE_WIDTH}%;
  margin: 0 20px;
  height: auto;
`;

const SliderWrapper = styled.div`
  width: 100%;
  height: 100%;
  perspective: 1000;
`;

const SlideWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: between;
  height: 100%;
`;

const SectionTitle = styled.h1`
  font-size: 40px;
  font-family: AvenirBold;
`;

const SectionDescription = styled.p`
  font-size: 20px;
  color: #3c3c3c;
  font-family: Avenir;
`;

const SmallSpacerDiv = styled.div`
  height: 50px;

  @media (max-width: 566px) {
    height: 30px;
  }
`;

export default ({ title, description, images, reverse, number }) => {
  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: `#scroll-slider-wrapper-${number}`,
        pin: true,
        start: 'center center',
        end: `+=${images.length * 40}%`,
        scrub: 1,
      },
    });

    if (reverse) {
      tl.fromTo(`#scroll-slider-${number}`, { x: '-33.3%' }, {x: '33.3%'});
    } else {
      tl.fromTo(`#scroll-slider-${number}`, { x: '0%' }, {x: '-66.6%'});
    }
  }, []);

  return (
    <SliderWrapper id={`scroll-slider-wrapper-${number}`}>
      <SmallSpacerDiv />
      <SectionTitle>{title}</SectionTitle>
      <SectionDescription>
        Our job is to bring what you’re thinking to life! With our renowned artists along with
        artwork that has been seen by millions, we ensure that we exceed your expectations and
        deliver something worthwhile. Your success is our success.
      </SectionDescription>
      <SmallSpacerDiv />
      <div id={`scroll-slider-${number}`} style={{ width: `${images.length * 40}%`, display: 'inline-flex' }}>
        {images.map(({ source }) => (
          <SliderImage src={source} />
        ))}
      </div>
    </SliderWrapper>
  );
};
